// extracted by mini-css-extract-plugin
module.exports = {"paged":"_2nwLq"};